import React from 'react';
import { Badge } from '@/components/ui/badge';
import { DUMMY_EMPLOYEES } from '@/components/zoho/proto/dummyData';

function ratingBadge(r) {
  var n = parseInt(r);
  if (n >= 5) return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  if (n >= 4) return 'bg-emerald-50 text-emerald-600 border-emerald-200';
  if (n >= 3) return 'bg-amber-50 text-amber-700 border-amber-200';
  return 'bg-red-50 text-red-700 border-red-200';
}

function approvalBadge(status) {
  if (status === 'Approved') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  if (status === 'Pending') return 'bg-amber-50 text-amber-700 border-amber-200';
  return 'bg-red-50 text-red-700 border-red-200';
}

function formatDate(d) {
  if (!d) return '-';
  return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function ProtoSubmissionTable({ onSelect, filtered }) {
  var data = filtered || DUMMY_EMPLOYEES;
  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden" data-testid="proto-submission-table">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-200">
              <th className="text-left px-4 py-3 font-semibold text-xs uppercase tracking-wider text-muted-foreground">Emp ID</th>
              <th className="text-left px-4 py-3 font-semibold text-xs uppercase tracking-wider text-muted-foreground">Name</th>
              <th className="text-left px-4 py-3 font-semibold text-xs uppercase tracking-wider text-muted-foreground">Department</th>
              <th className="text-left px-4 py-3 font-semibold text-xs uppercase tracking-wider text-muted-foreground">Job Title</th>
              <th className="text-left px-4 py-3 font-semibold text-xs uppercase tracking-wider text-muted-foreground">Rating</th>
              <th className="text-left px-4 py-3 font-semibold text-xs uppercase tracking-wider text-muted-foreground">Salary</th>
              <th className="text-left px-4 py-3 font-semibold text-xs uppercase tracking-wider text-muted-foreground">Increment</th>
              <th className="text-left px-4 py-3 font-semibold text-xs uppercase tracking-wider text-muted-foreground">Approval</th>
              <th className="text-left px-4 py-3 font-semibold text-xs uppercase tracking-wider text-muted-foreground">Last Submitted</th>
            </tr>
          </thead>
          <tbody>
            {data.map(function(emp) {
              return (
                <tr
                  key={emp.id}
                  className="border-b border-slate-100 hover:bg-slate-50/60 cursor-pointer transition-colors duration-100"
                  onClick={function() { onSelect(emp); }}
                  data-testid={'table-row-' + emp.empId}
                >
                  <td className="px-4 py-3 font-medium text-slate-700">#{emp.empId}</td>
                  <td className="px-4 py-3">
                    <div>
                      <p className="font-medium">{emp.name}</p>
                      <p className="text-xs text-muted-foreground">{emp.email}</p>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-slate-600">{emp.department}</td>
                  <td className="px-4 py-3 text-slate-600">{emp.jobTitle}</td>
                  <td className="px-4 py-3">
                    <Badge className={'text-xs font-semibold border ' + ratingBadge(emp.overallRating)} variant="outline">
                      {emp.overallRating}/5
                    </Badge>
                  </td>
                  <td className="px-4 py-3 font-medium">{Number(emp.currentSalary).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 })}</td>
                  <td className="px-4 py-3 font-medium text-emerald-700">{emp.suggestedIncrement}%</td>
                  <td className="px-4 py-3">
                    <Badge className={'text-xs border ' + approvalBadge(emp.managementApproval)} variant="outline">
                      {emp.managementApproval}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-muted-foreground">{formatDate(emp.lastSubmission)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
